<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <h3>編輯SI的開店郵件樣板</h3>
        <div>
          <p>
            參數說明：
            <ul>
              <li>shop.name 商店名稱</li>
              <li>shop.joinCode 商店管理綁定碼</li>
              <li>shop.codeExpiredAt 商店管理綁定碼過期時間</li>
              <li>shop.isDelivery 是否外送</li>
              <li>shop.isTakeout 是否外帶</li>
              <li>shop.isEatIn 是否內用</li>
              <li>shop.isMobilePayment 是否行動支付</li>
              <li>shop.lineAddFriendUrl 加入店家LINE@網址</li>
              <li>shop.lineBasicId 加入店家LINE@ID</li>
              <li>shop.webUrl 店家WEB版網址(有開WEB SSO才能運作)</li>
              <li>owner.name 申請人名稱</li>
              <li>owner.email 申請人郵件 </li>
              <li>eaa.name EAA名稱</li>
              <li>eaa.email EAA郵件</li>
              <li>notify.name 訂單Notify推播群組名稱</li>
              <li>notify.manUrl 訂單Notify推播群組綁定網址</li>
            </ul>
          </p>
        </div>
        <!-- <fg-input
          label="主旨"
          required
          v-model="subject"
          v-validate="modelValidations.subject"
          :error="getError('subject')"
          name="subject"
        ></fg-input> -->

        <!-- bidirectional data binding（双向数据绑定） -->
        <!-- <quill-editor
          v-model="content"
          ref="myQuillEditor"
          :options="editorOption"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @ready="onEditorReady($event)"
        ></quill-editor> -->

        <el-button v-if="user && user.type === 'gaa'" type="primary" size="mini" @click.native="switchEditor('ace')">原始碼編輯</el-button>
        <el-button v-if="user && user.type === 'gaa'" type="primary" size="mini" @click.native="switchEditor('ckeditor')">一般編輯</el-button><span class="mx-2">(請注意，一切換到一般編輯器即會改動部分HTML語法)</span>
        
        <div v-if="loading">載入資料中...</div>
        <formio src="" url="" :form="emailForm" submission="" options="" v-on:submit="formioSubmit"></formio>       

        <!-- <div class="d-flex justify-content-center">
          <n-button native-type="submit" @click.native.prevent="validate" type="success">儲存樣板並返回上一頁</n-button>
        </div> -->
        <!-- Or manually control the data synchronization（或手动控制数据流） -->
        <!-- <quill-editor :content="content" :options="editorOption" @change="onEditorChange($event)"></quill-editor> -->
      </card>
      <!-- small modal -->
      <modal
        :show.sync="modals.mini"
        class="modal-danger"
        :show-close="false"
        headerClasses="justify-content-center"
        type="mini"
      >
        <div slot="header" class="modal-profile">
          <i class="now-ui-icons ui-1_simple-remove"></i>
        </div>
        <p>
          <strong>{{modals.content}}</strong>
        </p>
        <template slot="footer">
          <!-- <n-button type="neutral" link>Back</n-button> -->
          <n-button type="neutral" link @click.native="modals.mini = false">Close</n-button>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";

// require styles
// import "quill/dist/quill.core.css";
// import "quill/dist/quill.snow.css";
// import "quill/dist/quill.bubble.css";
import { Form } from 'vue-formio';

// import { quillEditor } from "vue-quill-editor";

import { Modal } from "src/components";

export default {
  components: {
    // quillEditor,
    Modal,
    formio: Form 
  },
  computed: {
    user: function() {
      return this.$store.getters.user;
    }
  },
  data() {
    return {
      loading: true,
      emailForm: {
        "display": "form",
        "components": [
        ]
      },
      form: {},
      subject: "",
      content: "",
      to: "",
      modelValidations: {
        subject: {
          required: true
        }
      },
      // editorOption: { // quillEditor
      //   // some quill options
      //   modules: {
      //     toolbar: [
      //     ["bold", "italic", "underline", "strike"], // toggled buttons
      //     ["blockquote", "code-block"],

      //     [{ header: 1 }, { header: 2 }], // custom button values
      //     [{ list: "ordered" }, { list: "bullet" }],
      //     [{ script: "sub" }, { script: "super" }], // superscript/subscript
      //     [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
      //     [{ direction: "rtl" }], // text direction

      //     [{ size: ["small", false, "large", "huge"] }], // custom dropdown
      //     [{ header: [1, 2, 3, 4, 5, 6, false] }],

      //     [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      //     [{ font: [] }],
      //     [{ align: [] }],

      //     ["clean"], // remove formatting button
      //     ["link", "image", "video"],
      //     ["showHtml"]
      //   ]
      //   }
      // },
      modals: {
        content: "",
        mini: false
      }
    };
  },
  mounted() {
    this.renderEmail();
  },
  methods: {
    switchEditor(editor) {
      if (editor === 'ace') {
          this.emailForm = {
            "display": "form",
            components: [
              {
                "label": "主旨",
                "tableView": true,
                "validate": {
                    "required": true
                },
                "defaultValue": this.subject || "",
                "key": "subject",
                "type": "textfield",
                "input": true
              },
              {
                "label": "原始碼編輯",
                // "autoExpand": false,
                "tableView": true,
                "key": "emailSource",
                "customClass": "editorSize",
                "editor": "ace",
                "placeholder": "",
                "wysiwyg": {
                  "maxLines": 100,
                  "minLines": 10,
                  // "mode": "ace/mode/html", // vue-formio不支援javascript以外的mode
                  // "theme": "ace/theme/twilight",
                  "wrap": true,
                  // "autoScrollEditorIntoView": true
                },
                "validate": {
                  "required": true
                },
                "defaultValue": this.content || "",
                "type": "textarea",
                "input": true
                // "label": "Text Area",
                // "editor": "ace",
                // "tableView": true,
                // "key": "textArea",
                // "type": "textarea",
                // "input": true,
                // "isUploadEnabled": false
              },
               {
                  "type": "button",
                  "label": "儲存樣板並返回上一頁",
                  "customClass": "text-center",
                  "theme": "success",
                  "key": "submit",
                  "disableOnInvalid": true,
                  "input": true,
                  "tableView": false
              }
            ]
            
          }
      } else {
          this.emailForm = {
            "display": "form",
            components: [
                {
                "label": "主旨",
                "tableView": true,
                "validate": {
                    "required": true
                },
                "defaultValue": this.subject || "",
                "key": "subject",
                "type": "textfield",
                "input": true
              },
              {
                  "label": "CKEDITOR",
                  "editor": "ckeditor",
                  "autoExpand": false,
                  "tableView": true,
                  "key": "emailSource",
                  "defaultValue": this.content || "",
                  "type": "textarea",
                  "input": true,
                  "isUploadEnabled": false
              },
              {
                  "type": "button",
                  "label": "儲存樣板並返回上一頁",
                  "customClass": "text-center",
                  "theme": "success",
                  "key": "submit",
                  "disableOnInvalid": true,
                  "input": true,
                  "tableView": false
              }
            ]
            
          }
      }
    },
    formioSubmit(event) {
      // console.log('event ' + JSON.stringify(event));
      this.content = event.data.emailSource;
      this.subject = event.data.subject;
      this.validate();
    },
    renderEmail() {
      // render email by si account and shop data
      if (this.user.type === 'si') {
        return axios
        .get(`${process.env.VUE_APP_APIHOST}/si/shop-info-email-template`)
        .then(response => {
          this.content = response.data ? response.data["template"] : "";
          this.subject = response.data ? response.data["subject"] : "";
          this.switchEditor('ckeditor');
          this.loading = false;
          // console.log('the response ' + JSON.stringify(response.data));
          // self.model.email = response.data.email;
          // self.model.name = response.data.name;
          return response.data;
        })
        .catch(e => {
          if (e && e.data && e.data.message)
            this.modals.content = "尚未編輯開店信件樣板";

          this.modals.mini = true;
        });
      } else if (this.user.type === 'gaa') {
        // 抓取此商店的SI的樣板
        return axios
        .get(`${process.env.VUE_APP_APIHOST}/gaa/si-accounts/${this.$route.query.si_id}/shop-info-email-template`)
        .then(response => {
          this.content = response.data ? response.data["template"] : "";
          this.subject = response.data ? response.data["subject"] : "";
          this.switchEditor('ace');
          this.loading = false;
          // console.log('the response ' + JSON.stringify(response.data));
          // self.model.email = response.data.email;
          // self.model.name = response.data.name;
          return response.data;
        })
        .catch(e => {
          if (e && e.data && e.data.message)
            this.modals.content = "尚未編輯開店信件樣板";

          this.modals.mini = true;
        });
      }
      
    },
    validate() {
      console.log("check content " + this.content);
      if (!this.content) {
        this.modals.content = "尚未編輯開店信件樣板，請編輯後儲存";
        this.modals.mini = true;
      } else {
        if (this.user.type === 'si') {
          return axios
          .put(`${process.env.VUE_APP_APIHOST}/si/shop-info-email-template`, {
            template: this.content,
            subject: this.subject
          })
          .then(response => {
            // this.content = response.data;
            // console.log('the response ' + JSON.stringify(response.data));
            // self.model.email = response.data.email;
            // self.model.name = response.data.name;
            this.$router.push(
              `/account-email?shop_id=${this.$route.query.shop_id}&shop_name=${this.$route.query.shop_name}`
            );
            return response.data;
          })
          .catch(e => {
            this.modals.content = "儲存範本發生錯誤，請聯絡管理員";
            if (e && e.data && e.data.message)
              this.modals.content = e.data.message;

            this.modals.mini = true;
          });
        } else if (this.user.type === 'gaa') {
          return axios
          .put(`${process.env.VUE_APP_APIHOST}/gaa/si-accounts/${this.$route.query.si_id}/shop-info-email-template`, {
            template: this.content,
            subject: this.subject
          })
          .then(response => {
            // this.content = response.data;
            // console.log('the response ' + JSON.stringify(response.data));
            // self.model.email = response.data.email;
            // self.model.name = response.data.name;
            this.$router.push(
              `/account-email?shop_id=${this.$route.query.shop_id}&shop_name=${this.$route.query.shop_name}`
            );
            return response.data;
          })
          .catch(e => {
            this.modals.content = "儲存範本發生錯誤，請聯絡管理員";
            if (e && e.data && e.data.message)
              this.modals.content = e.data.message;

            this.modals.mini = true;
          });
        }
       
      }
    },
    onEditorBlur(quill) {
      console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      console.log("editor ready!", quill);
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    }
  }
};
</script>